import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const CustomModal = ({ isOpen, children }) => {
  return (
    <div>
      <Modal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}
      >
        <Box
          height={"100vh"}
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {children}
        </Box>
      </Modal>
    </div>
  );
};

export default CustomModal;
